import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const Cta = () => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!home) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <section
      className="hero banner d-flex align-items-center justify-content-center text-white text-center position-relative pt-4 mt-5"
      style={{
        height: "70vh",
        overflow: "hidden",
      }}
    >
      <div
        className="background-image"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/bb.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          filter: "blur(2px)",
          zIndex: -1,
        }}
      ></div>

      <div className="container">
        <h1 className="">{home.title[0].text}</h1>
        <div className="conference-date text-white py-2 px-4 mt-4 rounded">
          <h4>{home.conference_date[0].text}</h4>
        </div>
        <div className="conference-organised mt-3 h5 font-weight-medium">
          <h3>{home.location[0].text}</h3>
        </div>
        <div className="d-flex flex-row justify-content-center">
          <a
            className="nav-link link-button scrollto mx-3"
            target="_blank"
            href={home.paper_submission_link[0].text}
            rel="noopener noreferrer"
          >
            <button className="btn btn-light nav-btn nav-btn-mobile register-btn">
              Paper Submission
            </button>
          </a>

          <a
            className="nav-link link-button scrollto mx-3"
            target="_blank"
            href={home.registration_link[0].text}
            rel="noopener noreferrer"
          >
            <button className="btn btn-light nav-btn nav-btn-mobile register-btn">
              Registration
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Cta;
